import { deleteFromCollection, saveToCollection } from './mutations'
import { composeQuery, getId, getRootCollection } from './queries'
import { whereActive } from './common'

const whereAccountTypesInclude = (accountTypeId) => (query) =>
  query.where('accountTypes', 'array-contains', accountTypeId)

const whereAccount = (account) => (query) =>
  query.where('accountId', '==', account.id)

const whereCategories = (categories) => (query) =>
  query.where('categories', 'array-contains-any', categories.map(getId))

export const listTemplateCategories = () =>
  getRootCollection('templateCategories')

export const listActiveTemplateCategoriesForAccountType = (accountTypeId) =>
  composeQuery(
    listTemplateCategories,
    whereAccountTypesInclude(accountTypeId),
    whereActive
  )

export const listTemplates = () => getRootCollection('templates')

export const listActiveTemplatesForCategories = (categories) =>
  composeQuery(listTemplates, whereCategories(categories), whereActive)

export const listTemplatesForAccount = (account) =>
  composeQuery(listTemplates, whereAccount(account))

export const listActiveTemplatesForAccount = (account) =>
  composeQuery(() => listTemplatesForAccount(account), whereActive)

export const saveTemplate = saveToCollection(listTemplates)
export const deleteTemplate = deleteFromCollection(listTemplates)
